import { html, raw } from "../../render";
import { attr, cn, numberToPxValue } from "../../utils";
export const LP_ICON_WEIGHTS = ["regular", "fill"];
const weightClasses = {
    regular: "ph",
    fill: "ph-fill",
};
export function LpIcon({ name, label, size, className, weight = "regular", }) {
    if (!name) {
        return raw("");
    }
    const sizeValue = numberToPxValue(size);
    return html `
        <i
            data-lp-component="Icon"
            data-icon-weight="${weight}"
            class="${cn("lp-icon", weightClasses[weight], `ph-${name}`, className)}"
            ${attr("style", sizeValue ? `--lp-icon-size: ${sizeValue};` : undefined)}
            ${attr("aria-hidden", label ? undefined : "true")}
            ${attr("role", label ? "img" : undefined)}
            ${attr("aria-label", label)}
        ></i>
    `;
}
